import AppMode from '@/business/AppMode';

import Enterprise from './index.b2b';
import Personal from './index.personal';

export default AppMode.select({
  enterprise: Enterprise,
  personal: Personal,
});
